import styled from "styled-components";
import { colors, rgb } from "../../Assets/styles/colors";

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  overflow: visible;
`;

export const Status = styled.p`
  font-size: ${({ fontSize }) => fontSize || 16}px;
  line-height: 1.25;
  color: ${({ $speaking, $emotii, theme }) =>
    $emotii
      ? colors.emotiiPurple
      : $speaking
        ? colors.speakingGreen
        : theme.menu.secondaryTextColor};
  transition: color 0.3s ease;
`;

export const Name = styled.h3`
  font-size: ${({ fontSize }) => fontSize}px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  text-align: center;
`;

export const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const NameBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.68));
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid ${({ $speaking, $emotii }) =>
    $emotii ? `rgba(${rgb(colors.emotiiPurple)}, 0.5)`
    : $speaking ? `rgba(${rgb(colors.speakingGreen)}, 0.5)`
    : "rgba(255, 255, 255, 0.10)"};
  box-shadow: ${({ $speaking, $emotii }) =>
    $emotii ? `0 0 14px 2px rgba(${rgb(colors.emotiiPurple)}, 0.28), 0 2px 8px rgba(0,0,0,0.5)`
    : $speaking ? `0 0 14px 2px rgba(${rgb(colors.speakingGreen)}, 0.28), 0 2px 8px rgba(0,0,0,0.5)`
    : "0 2px 8px rgba(0, 0, 0, 0.45)"};
  position: absolute;
  bottom: 10px;
  left: 10px;
  border-radius: 20px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
`;

export const NameInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const NameBadgeText = styled.p`
  font-size: ${({ fontSize }) => fontSize || 12}px;
  font-weight: 500;
  letter-spacing: 0.2px;
  color: ${({ $speaking, $emotii }) =>
    $emotii ? colors.emotiiPurple
    : $speaking ? colors.speakingGreen
    : "rgba(255, 255, 255, 0.92)"};
  transition: color 0.3s ease;
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StatusText = styled.span`
  font-size: ${({ fontSize }) => fontSize || 9}px;
  font-weight: 400;
  color: ${({ $emotii }) => $emotii ? colors.emotiiPurple : colors.speakingGreen};
  opacity: 0.9;
`;

export const StatusAmp = styled.span`
  font-size: ${({ fontSize, $large }) => fontSize || ($large ? 16 : 9)}px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  opacity: 0.85;
`;

export const MutedIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const NameStrip = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.35));
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
`;

export const NameStripText = styled.p`
  font-size: ${({ fontSize }) => fontSize || 10}px;
  font-weight: 500;
  color: ${({ $speaking, $emotii }) =>
    $emotii ? colors.emotiiPurple
    : $speaking ? colors.speakingGreen
    : "rgba(255, 255, 255, 0.92)"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.3s ease;
`;
